import React from "react";

const ErrorMessage = ({ errorMessage,className }) => {
  return (
    <div className={`error_message_container ${className}`}>
      {errorMessage && (
        <p className="error_message_paragraph">{errorMessage}</p>
      )}
    </div>
  );
};

export default ErrorMessage;
